export default __webpack_public_path__ + "static/tip3-a68b34c51ae89e2a6cc3d7bba07c305a.png";